import React, { useEffect, useState, useRef } from 'react';
export function useScrollReveal(threshold = 0.15, rootMargin = '0px 0px -50px 0px') {
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        if (ref.current) observer.unobserve(ref.current);
      }
    }, {
      threshold,
      rootMargin
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [threshold, rootMargin]);
  return {
    ref,
    isVisible
  };
}
interface ScrollRevealProps {
  children: React.ReactNode;
  variant?: 'up' | 'left' | 'right' | 'scale' | 'clip';
  className?: string;
  delay?: number;
}
export function ScrollReveal({
  children,
  variant = 'up',
  className = '',
  delay = 0
}: ScrollRevealProps) {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  let baseStyle = 'transition-all duration-700 ease-out opacity-0 ';
  if (variant === 'up') baseStyle += 'translate-y-12 ';
  if (variant === 'left') baseStyle += '-translate-x-12 ';
  if (variant === 'right') baseStyle += 'translate-x-12 ';
  if (variant === 'scale') baseStyle += 'scale-90 ';
  if (variant === 'clip') baseStyle = 'transition-all duration-1000 ease-out [clip-path:inset(100%_0_0_0)] opacity-100 ';
  let visibleStyle = 'opacity-100 translate-y-0 translate-x-0 scale-100 ';
  if (variant === 'clip') visibleStyle = '[clip-path:inset(0_0_0_0)] opacity-100 ';
  return <div ref={ref} className={`${className} ${baseStyle} ${isVisible ? visibleStyle : ''}`} style={{
    transitionDelay: `${delay}ms`
  }} data-id="element-394">
      {children}
    </div>;
}